<!-- In your mfa-login.component.html -->
<br>
<br>
<h6 class="text-center mb-2">{{'mfa_transaction' | translate}}</h6>
<div class ="text-center">
 <i>({{'mfa_trans_desc' | translate}})</i>
</div>
<br>
<form [formGroup]="mfaForm" class="mfa-form">
  <mat-radio-group class="form-group" formControlName="selectedRadioOption" (change)="onRadioChange($event)">


    <!-- Dynamic Radio Buttons -->
    <mat-radio-button *ngFor="let option of radioOptions" [value]="option.authenticationTypeID" class="radio-option">
      {{ option.authenticationTypeName }}
    </mat-radio-button>

    <!-- Static Radio Button -->
    <mat-radio-button value="uniqueCode" class="radio-option">
      {{'send_code' | translate}}
    </mat-radio-button>
  </mat-radio-group>
  <mat-error class="text-danger" *ngIf="submitClicked && mfaForm.get('selectedRadioOption')?.hasError('required')">
   {{'please_select' | translate}}
  </mat-error>
  <!-- Dynamic Checkboxes, shown when the specific radio button is selected -->
  <div formGroupName="checkboxes" class="px-5" *ngIf="mfaForm.get('selectedRadioOption')?.value === 'uniqueCode'">
    <mat-checkbox *ngFor="let option of checkboxOptions" class="checkbox-option"
      [formControlName]="option.authenticationTypeID" (change)="updateSelectedCheckboxes(option, $event)">
      {{ option.authenticationTypeName }}
    </mat-checkbox>

    <div *ngIf="primary">
      <label for="selectedOptions">{{'select_primary_option' | translate}}</label>
      <select id="selectedOptions" [formControl]="selectedOptionsControl" (change)="selectChange()"
        class="form-control">
        <option value="" selected disabled>{{'select_primary_type' | translate }}</option>
        <option *ngFor="let option of selectedOptions" [value]="option.authenticationTypeID">{{
          option.authenticationTypeName }}</option>
      </select>
      <div *ngIf="submitClicked&&selectionReq &&! mfaForm?.hasError('noCheckboxSelected')" class="text-danger">
        {{'please_select_atleast' | translate}}
      </div>
    </div>

    <!-- Display error message only if submit button has been clicked -->
    <mat-error class="text-danger" *ngIf="submitClicked && mfaForm?.hasError('noCheckboxSelected')">
      {{'atleast_checkbox' | translate}}
    </mat-error>
  </div>

  <div class="text-center m-2">
    <button mat-button type="submit" class="btn btncancel" (click)="onFormSubmit('skip')">
      <em class="fa fa-check-circle"></em> {{'skip'|translate}}</button>&nbsp;&nbsp;
    <button type="button" class="btn btnc" (click)="onFormSubmit('submit')"><em class="fa fa-check-circle"></em> &nbsp;{{
      'SUBMIT' | translate }}</button>
  </div>

</form>